import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IAbstractView } from '@core/interfaces';
import { MenuItem } from '@core/models';
import { DialogTypeEnum } from '@shared/components/dialog/enums/dialog-type.enum';
import { SingleproductPresenter } from './singleproduct.presenter';
import { ISingleProductComponent, ISingleProductPresenter } from './interfaces';

@Component({
	selector: 'app-singleproduct',
	templateUrl: './singleproduct.component.html',
	styleUrls: ['./singleproduct.component.scss'],
	standalone: false,
	providers: [SingleproductPresenter],
})
export class SingleproductComponent extends IAbstractView<ISingleProductPresenter> implements ISingleProductComponent {
	translations = this.presenter.translations;
	formGroup = this.presenter.formGroup;
	decimalPrecision = '1.2-2';
	suggestionItems$ = this.presenter.suggestionItems$;

	@Input() isEditing = false;

	constructor(presenter: SingleproductPresenter) {
		super(presenter);
	}

	get articleName(): string {
		return this.formGroup.get('productosCanal.nombre')?.value || 'No name';
	}

	getModifierGroupsAsFormGroups(): FormGroup[] {
		return this.presenter.getModifierGroupsAsFormGroups();
	}

	addToOrder(): void {
		this.presenter.addToOrder();
	}

	isAddToOrderDisabled(): boolean {
		return this.presenter.isAddToOrderDisabled();
	}

	closeModal(): void {
		this.presenter.closeModal();
	}

	addSuggestionItem(article: MenuItem): void {
		this.presenter.addSuggestionItem(article);
	}

	get isLongMode(): boolean {
		return this.presenter.isLongMode();
	}

	get dialogType(): DialogTypeEnum {
		return this.presenter.getDialogType();
	}
}
